import { AxiosError } from 'axios'

type FieldErrors = Record<string, string>

interface BankConstraintErrorData {
	errorCode: string
	message: string
	duplicateFields?: string[]
}

export function handlePaymentGatewayFormError(
	error: Error,
): FieldErrors | null {
	if (!(error instanceof AxiosError)) return null

	const data = error.response?.data as BankConstraintErrorData | undefined
	if (!data?.errorCode || !data?.duplicateFields?.length) return null

	if (!data.errorCode.startsWith('DUPLICATE_')) return null

	const fieldErrors: FieldErrors = {}
	for (const field of data.duplicateFields) {
		fieldErrors[field] = data.message || 'ข้อมูลนี้ซ้ำกับบัญชีที่มีอยู่แล้ว'
	}

	return Object.keys(fieldErrors).length > 0 ? fieldErrors : null
}
